/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContentType } from './ContentType';
import {
    ContentTypeFromJSON,
    ContentTypeFromJSONTyped,
    ContentTypeToJSON,
    ContentTypeToJSONTyped,
} from './ContentType';

/**
 * 
 * @export
 * @interface LogEntry
 */
export interface LogEntry {
    /**
     * 
     * @type {number}
     * @memberof LogEntry
     */
    readonly id: number;
    /**
     * 
     * @type {ContentType}
     * @memberof LogEntry
     */
    readonly contentType: ContentType;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    objectPk: string;
    /**
     * 
     * @type {number}
     * @memberof LogEntry
     */
    objectId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    objectRepr: string;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    readonly action: string;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    readonly actionLabel: string;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    changesText?: string;
    /**
     * 
     * @type {any}
     * @memberof LogEntry
     */
    changes?: any | null;
    /**
     * 
     * @type {number}
     * @memberof LogEntry
     */
    actor?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    readonly actorDetails: string;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    cid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    remoteAddr?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LogEntry
     */
    timestamp?: Date;
    /**
     * 
     * @type {any}
     * @memberof LogEntry
     */
    additionalData?: any | null;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    readonly objectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    readonly verboseDescription: string;
    /**
     * 
     * @type {string}
     * @memberof LogEntry
     */
    readonly changesDisplayDict: string;
}

/**
 * Check if a given object implements the LogEntry interface.
 */
export function instanceOfLogEntry(value: object): value is LogEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    if (!('objectPk' in value) || value['objectPk'] === undefined) return false;
    if (!('objectRepr' in value) || value['objectRepr'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('actionLabel' in value) || value['actionLabel'] === undefined) return false;
    if (!('actorDetails' in value) || value['actorDetails'] === undefined) return false;
    if (!('objectUrl' in value) || value['objectUrl'] === undefined) return false;
    if (!('verboseDescription' in value) || value['verboseDescription'] === undefined) return false;
    if (!('changesDisplayDict' in value) || value['changesDisplayDict'] === undefined) return false;
    return true;
}

export function LogEntryFromJSON(json: any): LogEntry {
    return LogEntryFromJSONTyped(json, false);
}

export function LogEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contentType': ContentTypeFromJSON(json['content_type']),
        'objectPk': json['object_pk'],
        'objectId': json['object_id'] == null ? undefined : json['object_id'],
        'objectRepr': json['object_repr'],
        'action': json['action'],
        'actionLabel': json['action_label'],
        'changesText': json['changes_text'] == null ? undefined : json['changes_text'],
        'changes': json['changes'] == null ? undefined : json['changes'],
        'actor': json['actor'] == null ? undefined : json['actor'],
        'actorDetails': json['actor_details'],
        'cid': json['cid'] == null ? undefined : json['cid'],
        'remoteAddr': json['remote_addr'] == null ? undefined : json['remote_addr'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'additionalData': json['additional_data'] == null ? undefined : json['additional_data'],
        'objectUrl': json['object_url'],
        'verboseDescription': json['verbose_description'],
        'changesDisplayDict': json['changes_display_dict'],
    };
}

  export function LogEntryToJSON(json: any): LogEntry {
      return LogEntryToJSONTyped(json, false);
  }

  export function LogEntryToJSONTyped(value?: Omit<LogEntry, 'id'|'content_type'|'action'|'action_label'|'actor_details'|'object_url'|'verbose_description'|'changes_display_dict'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'object_pk': value['objectPk'],
        'object_id': value['objectId'],
        'object_repr': value['objectRepr'],
        'changes_text': value['changesText'],
        'changes': value['changes'],
        'actor': value['actor'],
        'cid': value['cid'],
        'remote_addr': value['remoteAddr'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'additional_data': value['additionalData'],
    };
}

